import React, { Fragment, useEffect, useRef, useState } from "react";
import { useEffectOnce } from "../../../hooks/useeffectonce";
import { useSelector, useDispatch } from "react-redux";
import {
  setProcessing,
  setPageValue,
  setSettingsFormValue,
  setSettingsFormOuterValue,
  setSettingsFormSettingValue,
  setFilterFormValue,
  setFieldValue,
  disposePage,
  loadReportPage,
  showSettingsForm,
  closeSettingsForm,
  settingsFormSave,
  resetTileWidget,
  updateSchema,
  showFilterForm,
  clearFilterForm,
  closeFilterForm,
  setFilterFormParameter,
  filterFormSave,
  filterFormPrevious,
  filterFormNext,
  setFilterFormOuterValue,
  zoomIn,
  zoomOut,
  globalGenerateReport,
  globalCancelReport,
  saveSearchSchema,
  showFilterFormValueKeys,
  closeFilterFormValueKeys,
  setFilterFormValueKeysValue,
  loadSchemaSearch,
  autoGlobalGenerate,
  closeSchedulePopup,
} from "../../../redux/slices/reportingviewpageslice";
import { setPageCommands } from "../../../redux/slices/dictaphoneslice";
import { addNotification } from "../../../redux/slices/notificationsslice";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { apiErrorsHandler, getErrorMessages } from "../../../api/httpclient";
import { Page } from "../../page";
import {
  isInteger,
  isEmptyObject,
  isNumeric,
  notificationDurationMiddle,
  beepFile,
  updateRuleAtPath,
} from "../../../lib/utils";
import { Loader } from "@progress/kendo-react-indicators";
import { TileLayout } from "@progress/kendo-react-layout";
import {
  isChart,
  isMinMaxChart,
  WIDGET_GAUGE_CARD,
  WIDGET_GRID,
  WIDGET_LINE_CHART,
  validateParameters,
  combineParameters,
  DEFAULT_ROW_HEIGHT,
  getTilesForGenerateGlobalReport,
} from "../../../components/widgets/utils";
import {
  Toolbar,
  ToolbarItem,
  ToolbarSeparator,
  Button,
} from "@progress/kendo-react-buttons";
import { Dialog } from "@progress/kendo-react-dialogs";
import { WidgetSettingsForm } from "../design/widgetsettingsform";
import { WidgetFilterForm } from "./widgetfilterform";
import { WidgetFilterFormSinglePage } from "./widgetfilterformsinglepage";
import { ReportingViewPageKeyValues } from "./reportingviewpagekeyvalues";
import { parseDate } from "@progress/kendo-intl";
import * as htmlToImage from "html-to-image";
import download from "downloadjs";
import { APP_HEADER_HEIGHT } from "../../../settings";

import "./reportingviewpage.css";
import { canManageSearchSchemaReport } from "../../../routing/authorizationhandlers";
import { useKendoGridTouchDragFix } from "../../../hooks/useKendoGridTouchDragFix";

import i18next from "i18next";
import { useTranslation } from "react-i18next";

export const ReportingViewPage = (props) => {
  const dispatch = useDispatch();
  const pageState = useSelector((state) => state.reportingViewPage);
  const currentTheme = useSelector((state) => state.currentTheme);
  const appearance = useSelector((state) => state.appearance);
  const currentUser = useSelector((state) => state.currentUser); //currentUser.ClientId != null
  const navigate = useNavigate();
  const { id } = useParams();
  const appInit = useSelector((state) => state.appInit);

  const canManageSearchSchema = canManageSearchSchemaReport(currentUser);
  const { t } = useTranslation();
  const [isMobileTileLayout, setIsMobileTileLayout] = useState(
    () => window.matchMedia("(max-width: 1024px)").matches,
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 1024px)");
    const updateTileLayout = (event) => setIsMobileTileLayout(event.matches);

    mediaQuery.addEventListener("change", updateTileLayout);
    return () => mediaQuery.removeEventListener("change", updateTileLayout);
  }, []);

  useKendoGridTouchDragFix(!isMobileTileLayout);

  //const pageMode = pageState.reportId == null || pageState.reportId < 1 ? 1 : 2;

  /*initial page load*/
  // const commands = [
  //     {
  //         command: ['generate'],
  //         callback: (keyword) =>
  //         {
  //             beepFile("/sounds/any.mp3");
  //             generateGlobalReport();
  //         }
  //     },
  //     {
  //         command: ['update'],
  //         callback: (keyword) =>
  //         {
  //             beepFile("/sounds/any.mp3");
  //             handleOnUpdateSchema();
  //         }
  //     },
  //     {
  //         command: ['zoom in'],
  //         callback: (keyword) =>
  //         {
  //             beepFile("/sounds/any.mp3");
  //             dispatch(zoomIn());
  //         }
  //     },
  //     {
  //         command: ['zoom out'],
  //         callback: (keyword) =>
  //         {
  //             beepFile("/sounds/any.mp3");
  //             dispatch(zoomOut());
  //         }
  //     },
  //     {
  //         command: ['favorite', 'favourite'],
  //         callback: (keyword) =>
  //         {
  //             beepFile("/sounds/any.mp3");
  //             handleOnToggleIsFavorite();
  //         }
  //     },
  //     {
  //         command: ['camera', 'snapshot'],
  //         callback: (keyword) =>
  //         {
  //             beepFile("/sounds/camera.mp3");
  //             handleOnSnapshot();
  //         }
  //     },
  //     {
  //         command: ['go live', 'go life', 'go on', 'go online'],
  //         callback: (keyword) =>
  //         {
  //             beepFile("/sounds/any.mp3");
  //             dispatch(setPageValue({id: "isLiveReport", value: true}))
  //         }
  //     },
  //     {
  //         command: ['go off', 'go offline'],
  //         callback: (keyword) =>
  //         {
  //             beepFile("/sounds/any.mp3");
  //             dispatch(setPageValue({id: "isLiveReport", value: false}))
  //         }
  //     },
  //     {
  //         command: ['extra height', 'more height', 'increase height'],
  //         callback: (keyword) =>
  //         {
  //             beepFile("/sounds/any.mp3");
  //             handleOnPaperHeightIncrease();
  //         }
  //     },
  //     {
  //         command: ['decrease height', 'less height'],
  //         callback: (keyword) =>
  //         {
  //             beepFile("/sounds/any.mp3");
  //             handleOnPaperHeightDecrease();
  //         }
  //     },
  //     {
  //         command: ['design mode', 'design'],
  //         callback: (keyword) =>
  //         {
  //             beepFile("/sounds/open.mp3");
  //             handleOnGotoDesignMode();
  //         }
  //     },
  // ];

  const location = useLocation();

  useEffect(() => {
    let _id = id;

    //if (!isInteger(id.toString()) || parseInt(id.toString()) < 0)
    if (!_id || _id.toString().trim() == "") {
      //not found
      navigate("/notfound", { replace: true });
      return;
    }

    _id = _id.toString().trim();

    //get page data
    if (!appInit.isSignalRLinked)
      dispatch(
        setProcessing({
          processing: true,
          processingText: t("reporting.view.loading"),
        }),
      );

    window.setTimeout(
      () => {
        dispatch(loadReportPage(_id, t)).then(
          (data) => {
            //console.log("DATA", data)
            let response = data.response;
            let freshPageState = data.pageState;
            if (
              freshPageState.generateOnLoad &&
              freshPageState.searchSchema &&
              freshPageState.datasets &&
              freshPageState.datasets.length == 1
            )
              generateGlobalReport(freshPageState);
          },
          (err) => {
            //hide loader
            dispatch(setProcessing({ processing: false }));

            const handleResponseReceived = (
              state,
              dispatch,
              navigate,
              payload,
            ) => {
              let errorMessages = payload?.data?.ErrorMessages;

              //notify with error
              if (!errorMessages || errorMessages.length == 0)
                dispatch(
                  addNotification({
                    text: t("reporting.view.loading_errormessage"),
                    type: "error",
                    closable: true,
                    duration: notificationDurationMiddle,
                    position: "topRight",
                  }),
                );
              else {
                errorMessages = getErrorMessages(errorMessages, 1);
                dispatch(
                  addNotification({
                    text: errorMessages[0],
                    type: "error",
                    closable: true,
                    duration: notificationDurationMiddle,
                    position: "topRight",
                  }),
                );
              }

              //go home
              navigate("/", { replace: true });
            };

            const handleUnhandled = (state, dispatch, navigate, payload) => {
              dispatch(
                addNotification({
                  text: t("reporting.view.unknown_error"),
                  type: "error",
                  closable: true,
                  duration: notificationDurationMiddle,
                  position: "topRight",
                }),
              );
              navigate("/", { replace: true });
            };

            apiErrorsHandler({}, dispatch, navigate, err, "/", {
              responseReceived: handleResponseReceived,
              unhandled: handleUnhandled,
            });
          },
        );
      },
      !appInit.isSignalRLinked ? 3500 : 0,
    );

    return () => {
      document.title = t("reporting.view.intelligence");
      dispatch(disposePage(true));
    };
  }, [location.pathname]);

  // useEffect(() => {
  //     dispatch(setPageCommands(commands));
  // });
  /*initial page load*/

  /*tiles reposition*/
  const isTileResizing = useRef(false);
  const resizingTileId = useRef(0);

  const handleOnTileResizeFinished = (e) => {
    if (isTileResizing.current == true && resizingTileId) {
      const tileId = resizingTileId.current;
      isTileResizing.current = false;
      resizingTileId.current = 0;

      window.removeEventListener("mouseup", handleOnTileResizeFinished);

      let widgetTypeId = pageState.tiles.find(
        (e) => e.Id == tileId,
      ).WidgetTypeId;

      if (
        tileId &&
        (isChart(widgetTypeId) || widgetTypeId == WIDGET_GAUGE_CARD)
      ) {
        dispatch(resetTileWidget(tileId));
      }
    }
  };

  const handleTilesReposition = (e) => {
    dispatch(
      setPageValue({
        id: "tiles",
        value: pageState.tiles.map((item, index) => {
          return { ...item, defaultPosition: { ...e.value[index] } };
        }),
      }),
    );

    let oldArr = e.target.props.positions;
    let newArr = e.value;
    let index = -1;

    for (let i in oldArr) {
      if (oldArr[i].order != newArr[i].order || oldArr[i].col != newArr[i].col)
        return;
      if (
        oldArr[i].colSpan != newArr[i].colSpan ||
        oldArr[i].rowSpan != newArr[i].rowSpan
      )
        index = i;
    }

    //I am here => resize
    let tile = pageState.tiles.find(
      (e) => e.defaultPosition.order == newArr[index].order,
    );
    if (!isTileResizing.current) {
      isTileResizing.current = true;
      resizingTileId.current = tile.Id;

      window.addEventListener("mouseup", handleOnTileResizeFinished);
    }
  };

  const paperContentRef = useRef(null);

  const handleOnPaperHeightIncrease = (e) => {
    paperContentRef.current.element.style.height =
      paperContentRef.current.element.clientHeight + 50 + "px";
  };

  const handleOnPaperHeightDecrease = (e) => {
    paperContentRef.current.element.style.height =
      paperContentRef.current.element.clientHeight - 50 + "px";
  };
  /*tiles reposition*/

  /*live report*/
  const handleOnToggleIsLiveReport = (e) =>
    dispatch(
      setPageValue({ id: "isLiveReport", value: !pageState.isLiveReport }),
    );
  /*live report*/

  /*is favorite*/
  const handleOnToggleIsFavorite = (e) =>
    dispatch(setPageValue({ id: "isFavorite", value: !pageState.isFavorite }));
  /*is favorite*/

  /*settings form*/
  const settingsFormValidator = (formValues) => {
    let formState = pageState.settingsForm;
    let values = formValues.settings;

    let formErrors = {};
    const widgetTypeId = formState.widgetTypeId;

    if (!isChart(widgetTypeId)) return undefined;

    const _isMinMax = isMinMaxChart(widgetTypeId);

    //i am here => validate
    let categoryFieldId = values["categoryFieldId"];
    let valueFieldId = values["valueFieldId"];
    let secondaryFieldId = values["secondaryFieldId"];
    let aggregate = values["aggregate"];
    let legendPosition = values["legendPosition"];
    let lineStyle = values["lineStyle"];

    if (categoryFieldId < 1)
      formErrors = Object.assign(formErrors, {
        "settings.categoryFieldId": t("reporting.view.field"),
      });

    if (valueFieldId < 1)
      formErrors = Object.assign(formErrors, {
        "settings.valueFieldId": t("reporting.view.field1"),
      });

    if (
      categoryFieldId > 0 &&
      valueFieldId > 0 &&
      categoryFieldId == valueFieldId
    )
      formErrors = Object.assign(formErrors, {
        "settings.valueFieldId": t("reporting.view.field2"),
      });

    if (
      secondaryFieldId > 0 &&
      categoryFieldId > 0 &&
      secondaryFieldId == categoryFieldId
    )
      formErrors = Object.assign(formErrors, {
        "settings.secondaryFieldId": t("reporting.view.field3"),
      });

    if (
      secondaryFieldId > 0 &&
      valueFieldId > 0 &&
      secondaryFieldId == valueFieldId
    )
      formErrors = Object.assign(formErrors, {
        "settings.secondaryFieldId": t("reporting.view.field4"),
      });

    if (!_isMinMax) {
      //aggregate is required
      if (!aggregate || aggregate.trim() == "")
        formErrors = Object.assign(formErrors, {
          "settings.aggregate": t("reporting.view.field5"),
        });
    } else {
      //if either aggregate or secondary field exists => both must exist
      if (
        (secondaryFieldId >= 1 && (!aggregate || aggregate.trim() == "")) ||
        (secondaryFieldId < 1 && aggregate && aggregate.trim() != "")
      )
        formErrors = Object.assign(formErrors, {
          "settings.secondaryFieldId": t("reporting.view.field6"),
        });
    }

    if (widgetTypeId == WIDGET_LINE_CHART && lineStyle < 1)
      formErrors = Object.assign(formErrors, {
        "settings.lineStyle": t("reporting.view.field7"),
      });

    if (isEmptyObject(formErrors)) return undefined;

    return formErrors;
  };

  const handleOnSettingsFormFieldValueChange = (obj) => {
    dispatch(setSettingsFormSettingValue({ id: obj.id, value: obj.value }));
  };

  const handleOnSettingsFormSave = () => {
    const dataSourceId = pageState.settingsForm.formValues.dataSourceId;

    //validation
    const isValidForm =
      settingsFormValidator(pageState.settingsForm.formValues) == undefined;

    if (!isValidForm) {
      dispatch(
        addNotification({
          text: t("reporting.view.invaliddata"),
          type: "error",
          closable: true,
          duration: 3,
          position: "topRight",
        }),
      );
      return;
    }

    dispatch(settingsFormSave());
  };

  const handleOnCloseSettingsForm = (e) => {
    dispatch(closeSettingsForm());
  };
  /*settings form*/

  //zooming
  const zoomTransformOrigin = pageState.zoom >= 1 ? "top left" : "center 0%";

  //snapshot
  const contentZoneRef = useRef(null);

  const getSnapshot = async (e) => {
    let w = parseInt(contentZoneRef.current.innerWidth);
    let h = parseInt(contentZoneRef.current.innerHeight); //parseInt(w * 0.75);

    let dataUrl = null;

    try {
      dataUrl = await htmlToImage.toJpeg(contentZoneRef.current, {
        width: w,
        height: h,
        quality: 0.9, //skipAutoScale: true,
        //backgroundColor: "#002240"
      });

      return dataUrl;
    } catch (ex) {
      return null;
    }
  };

  const handleOnSnapshot = async (e) => {
    let dataUrl = await getSnapshot();
    if (dataUrl) download(dataUrl, "vas-report.jpg");
  };

  const handleOnSchedule = () => {
    navigate("/createschedule?rptid=" + pageState.reportReferenceKey);
  };

  const handleOnWidgetSchedule = (id) => {
    navigate(
      "/createschedule?rptid=" +
        pageState.reportReferenceKey +
        "&widgetid=" +
        id,
    );
  };

  const handleOnGotoDesignMode = () => {
    navigate("/reportingdesign/" + pageState.reportReferenceKey);
  };

  const handleOnUpdateSchema = () => {
    dispatch(updateSchema(t)).then(
      (response) => {},
      (err) => {
        //hide loader
        dispatch(setProcessing({ processing: false }));

        const handleResponseReceived = (state, dispatch, navigate, payload) => {
          let errorMessages = payload?.data?.ErrorMessages;

          //notify with error
          if (!errorMessages || errorMessages.length == 0)
            dispatch(
              addNotification({
                text: t("reporting.view.saveschema"),
                type: "error",
                closable: true,
                duration: 3,
                position: "topRight",
              }),
            );
          else {
            errorMessages = getErrorMessages(errorMessages, 1);
            dispatch(
              addNotification({
                text: errorMessages[0],
                type: "error",
                closable: true,
                duration: 3,
                position: "topRight",
              }),
            );
          }
        };

        const handleUnhandled = (state, dispatch, navigate, payload) => {
          dispatch(
            addNotification({
              text: t("reporting.view.unknown_error"),
              type: "error",
              closable: true,
              duration: 3,
              position: "topRight",
            }),
          );
        };

        apiErrorsHandler({}, dispatch, navigate, err, null, {
          responseReceived: handleResponseReceived,
          unhandled: handleUnhandled,
        });
      },
    );
  };

  /*filter form*/
  const handleOnFilterParameterChange = ({
    formRenderProps,
    id,
    name,
    dataTypeId,
    isRequired,
    allowMultiple,
    isLookup,
    value,
  }) => {
    if (dataTypeId == 1)
      dispatch(setFilterFormParameter({ name: name, value: value }));
    else if (dataTypeId == 3)
      dispatch(setFilterFormParameter({ name: name, value: value }));
    else if (dataTypeId == 4 || dataTypeId == 5)
      dispatch(setFilterFormParameter({ name: name, value: value }));
    else if (dataTypeId == 2) {
      //if number and not lookup and not a numeric value => store ""
      if (!isLookup) {
        if (!isNumeric(value)) {
          formRenderProps.onChange(name, { value: "" });
          dispatch(setFilterFormParameter({ name: name, value: "" }));
        } else dispatch(setFilterFormParameter({ name: name, value: value }));
      } else {
        dispatch(setFilterFormParameter({ name: name, value: value }));
      }
    }
  };

  const filterFormValidator = (formValues) => {
    let formState = pageState.filterForm;
    let parameters = formState.parameters;

    if (!parameters || parameters.length < 1) return undefined;

    let formErrors = {};

    for (let i in parameters) {
      let parameter = parameters[i];
      let value = formValues[parameter.Name];

      if (
        parameter.IsRequired &&
        parameter.DataTypeId == 2 &&
        parameter.IsLookup == false &&
        isNumeric(value) == false
      )
        formErrors = Object.assign(formErrors, {
          [parameter.Name]: t("reporting.view.invalidvalue"),
        });

      if (parameter.IsRequired) {
        if (parameter.DataTypeId == 1 && value == null)
          formErrors = Object.assign(formErrors, {
            [parameter.Name]: t("reporting.view.check"),
          });

        if (parameter.DataTypeId == 2) {
          // if (!parameter.IsLookup && (value == null || value == ""))
          //     formErrors = Object.assign(formErrors, {[parameter.Name]: "Please, insert a numeric value"});

          if (parameter.IsLookup && parameter.AllowMultiple == false && !value)
            formErrors = Object.assign(formErrors, {
              [parameter.Name]: t("reporting.view.option"),
            });

          if (
            parameter.IsLookup &&
            parameter.AllowMultiple &&
            (!value || value.length < 1)
          )
            formErrors = Object.assign(formErrors, {
              [parameter.Name]: t("reporting.view.options"),
            });
        }

        if (parameter.DataTypeId == 3 && (value == null || value.trim() == ""))
          formErrors = Object.assign(formErrors, {
            [parameter.Name]: t("reporting.view.insert"),
          });

        if (
          (parameter.DataTypeId == 4 || parameter.DataTypeId == 5) &&
          (value == null || value.toString().trim() == "" || !parseDate(value))
        )
          formErrors = Object.assign(formErrors, {
            [parameter.Name]: t("reporting.view.validdate"),
          });
      }
    }

    if (isEmptyObject(formErrors)) return undefined;

    return formErrors;
  };

  const handleOnFilterSearchChange = (q) => {
    //console.log(">", q)
    dispatch(setFilterFormOuterValue({ id: "whereObject", value: q }));
  };

  const handleOnFilterFormPrevious = (e) => {
    dispatch(filterFormPrevious());
  };

  const handleOnFilterFormNext = (e) => {
    dispatch(filterFormNext());
  };

  const handleOnFilterFormValueChange = (e) =>
    dispatch(setFilterFormOuterValue(e));

  const handleOnFilterFormSave = () => {
    //proceed
    dispatch(filterFormSave());
  };

  const handleOnFilterFormSearchSchemaSave = () => {
    dispatch(saveSearchSchema(t)).then(
      (response) => {},
      (err) => {
        //hide loader
        dispatch(setProcessing({ processing: false }));

        const handleResponseReceived = (state, dispatch, navigate, payload) => {
          let errorMessages = payload?.data?.ErrorMessages;

          //notify with error
          if (!errorMessages || errorMessages.length == 0)
            dispatch(
              addNotification({
                text: t("reporting.view.loading_errormessage"),
                type: "error",
                closable: true,
                duration: notificationDurationMiddle,
                position: "topRight",
              }),
            );
          else {
            errorMessages = getErrorMessages(errorMessages, 1);
            dispatch(
              addNotification({
                text: errorMessages[0],
                type: "error",
                closable: true,
                duration: notificationDurationMiddle,
                position: "topRight",
              }),
            );
          }
        };

        const handleUnhandled = (state, dispatch, navigate, payload) => {
          dispatch(
            addNotification({
              text: t("reporting.view.unknown_error"),
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            }),
          );
        };

        apiErrorsHandler({}, dispatch, null, err, "", {
          responseReceived: handleResponseReceived,
          unhandled: handleUnhandled,
        });
      },
    );
  };

  const handleOnFilterFormValueKeysValueChange = (item) => {
    dispatch(setFilterFormValueKeysValue(item));
  };

  const handleOnFilterFormSearchSchemaLoad = () => {
    dispatch(loadSchemaSearch());
  };
  /*filter form*/

  /*generate*/
  const generateGlobalReport = (freshPageState) => {
    let ps = freshPageState ? freshPageState : pageState;

    const newRequestId =
      Math.ceil(Math.random() * 100000000 + 1).toString() +
      Date.now().toString(); // (new Date()).toString();

    let tiles = getTilesForGenerateGlobalReport(ps, newRequestId);

    dispatch(globalGenerateReport(tiles)).then(
      (response) => {
        //dispatch(setPageCommands(commands));
      },
      (err) => {
        //hide loader
        dispatch(setProcessing({ processing: false }));
        dispatch(globalCancelReport());

        //do not show notification if failed because timeout and global request id is not newRequestId
        if (
          err &&
          err.succeeded == false &&
          err.timedOut &&
          ps.globalRequestId != newRequestId
        )
          return;

        const handleResponseReceived = (state, dispatch, navigate, payload) => {
          let errorMessages = payload?.data?.ErrorMessages;

          //notify with error
          if (!errorMessages || errorMessages.length == 0)
            dispatch(
              addNotification({
                text: t("reporting.view.generate_error"),
                type: "error",
                closable: true,
                duration: notificationDurationMiddle,
                position: "topRight",
              }),
            );
          else {
            errorMessages = getErrorMessages(errorMessages, 1);
            dispatch(
              addNotification({
                text: errorMessages[0],
                type: "error",
                closable: true,
                duration: notificationDurationMiddle,
                position: "topRight",
              }),
            );
          }
        };

        const handleUnhandled = (state, dispatch, navigate, payload) => {
          dispatch(
            addNotification({
              text: t("reporting.view.unknown_error"),
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            }),
          );
        };

        apiErrorsHandler({}, dispatch, navigate, err, null, {
          responseReceived: handleResponseReceived,
          unhandled: handleUnhandled,
        });
      },
    );
  };

  const cancelGlobalReport = () => {
    dispatch(globalCancelReport());
  };
  /*generate*/

  const loading = pageState.tiles.find((e) => e.requestId);

  const handleKeyChange = (keyId, path) => {
    debugger;
    const currentQuery = pageState.filterForm.whereObject;
    const updatedQuery = updateRuleAtPath(currentQuery, path, keyId);
    dispatch(setFilterFormValue({ id: "whereObject", value: updatedQuery }));
  };

  const mobileTilePositions = (() => {
    let nextRow = 1;

    return pageState.tiles.map((tile) => {
      const minimumRowSpan = tile.WidgetTypeId == WIDGET_GRID ? 40 : 1;
      const rowSpan = Math.max(
        tile.defaultPosition.rowSpan || 1,
        minimumRowSpan,
      );
      const position = {
        ...tile.defaultPosition,
        col: 1,
        row: nextRow,
        colSpan: 1,
        rowSpan,
      };

      nextRow += rowSpan;
      return position;
    });
  })();

  const responsiveTiles = isMobileTileLayout
    ? pageState.tiles.map((tile) => ({
        ...tile,
        reorderable: false,
        resizable: false,
      }))
    : pageState.tiles;

  return (
    <Fragment>
      <Page
        id="reportingViewPage"
        className="reporting-view-page"
        title={t("reporting.view.reporting")}
      >
        <Fragment>
          {pageState.processing && (
            <div className="page-loader">
              <Loader
                size={"large"}
                type="infinite-spinner"
                themeColor={"primary"}
              />
              {pageState.processingText && (
                <div style={{ fontSize: 13, color: currentTheme.primary }}>
                  {pageState.processingText}
                </div>
              )}
            </div>
          )}
          {pageState.pageLoaded && (
            <div className="reporting-view-page-content">
              <div className="toolbar">
                <Toolbar>
                  {pageState.canEdit &&
                    !currentUser.ClientId &&
                    !pageState.isSystem && (
                      <Fragment>
                        <ToolbarItem className="reporting-toolbar-update">
                          <Button
                            disabled={pageState.processing}
                            style={{ color: currentTheme.primary }}
                            icon={"save"}
                            onClick={handleOnUpdateSchema}
                          >
                            {t("reporting.view.update")}
                          </Button>
                        </ToolbarItem>
                        <ToolbarSeparator />
                      </Fragment>
                    )}
                  {pageState.datasets.length == 1 && (
                    <Fragment>
                      <ToolbarItem className="reporting-toolbar-global-filter">
                        <Button
                          disabled={pageState.processing}
                          style={{ color: currentTheme.primary }}
                          icon={"filter"}
                          onClick={(e) => {
                            dispatch(showFilterForm(null));
                          }}
                        >
                          {t("reporting.view.filter")}
                        </Button>
                      </ToolbarItem>
                      <ToolbarSeparator />
                    </Fragment>
                  )}
                  {!pageState.globalGenerate && (
                    <Fragment>
                      <ToolbarItem className="reporting-toolbar-generate">
                        <Button
                          disabled={pageState.processing}
                          style={{ color: currentTheme.primary }}
                          icon={"reset"}
                          onClick={(e) => generateGlobalReport()}
                        >
                          {t("reporting.view.generate")}
                        </Button>
                      </ToolbarItem>
                      <ToolbarSeparator />
                    </Fragment>
                  )}
                  {pageState.globalGenerate && (
                    <Fragment>
                      <ToolbarItem className="reporting-toolbar-cancel">
                        <Button
                          disabled={pageState.processing}
                          style={{ color: currentTheme.primary }}
                          icon={"cancel"}
                          onClick={cancelGlobalReport}
                        >
                          {t("reporting.view.cancel")}
                        </Button>
                      </ToolbarItem>
                      <ToolbarSeparator />
                    </Fragment>
                  )}
                  {pageState.canEdit &&
                    !currentUser.ClientId &&
                    !pageState.isSystem && (
                      <Fragment>
                        <ToolbarItem className="reporting-toolbar-live">
                          <Button
                            disabled={pageState.processing}
                            className="is-live-report"
                            style={{}}
                            title={`${pageState.isLiveReport ? t("reporting.view.live") : t("reporting.view.notlive")}`}
                            icon={`${pageState.isLiveReport ? "radiobutton-checked" : "radiobutton"}`}
                            onClick={handleOnToggleIsLiveReport}
                          ></Button>
                        </ToolbarItem>
                        <ToolbarSeparator />
                      </Fragment>
                    )}
                  <Fragment>
                    <ToolbarItem className="reporting-toolbar-paper-height">
                      <Button
                        title={t("reporting.view.decrease")}
                        disabled={pageState.processing}
                        style={{ color: currentTheme.primary }}
                        icon={"minus"}
                        onClick={handleOnPaperHeightDecrease}
                      ></Button>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: 13,
                          color: currentTheme.toolbarText,
                        }}
                      >
                        {t("reporting.view.height")}
                      </div>
                      <Button
                        title={t("reporting.view.decrease")}
                        disabled={pageState.processing}
                        style={{ color: currentTheme.primary }}
                        icon={"plus"}
                        onClick={handleOnPaperHeightIncrease}
                      ></Button>
                    </ToolbarItem>
                    <ToolbarSeparator />
                  </Fragment>
                  <Fragment>
                    <ToolbarItem className="reporting-toolbar-zoom">
                      <Button
                        disabled={pageState.processing}
                        style={{ color: currentTheme.primary }}
                        icon={"zoom-out"}
                        onClick={(e) => dispatch(zoomOut())}
                      ></Button>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: 13,
                          color: currentTheme.toolbarText,
                        }}
                      >
                        {pageState.zoom * 100}%
                      </div>
                      <Button
                        disabled={pageState.processing}
                        style={{ color: currentTheme.primary }}
                        icon={"zoom-in"}
                        onClick={(e) => dispatch(zoomIn())}
                      ></Button>
                    </ToolbarItem>
                    <ToolbarSeparator />
                  </Fragment>
                  {/* {
                                    pageState.canEdit && !currentUser.ClientId && 
                                    <Fragment>
                                        <ToolbarItem>
                                            <Button disabled={pageState.processing} className="is-favorite"  
                                                title={`${pageState.isFavorite ? "Favorite" : "Not Favorite"}`}  
                                                icon={`${pageState.isFavorite ? 'heart' : 'heart-outline' }`} onClick={handleOnToggleIsFavorite}>
                                            </Button>
                                        </ToolbarItem>
                                        <ToolbarSeparator/>
                                    </Fragment>
                                } */}
                  <Fragment>
                    <ToolbarItem className="reporting-toolbar-schedule">
                      <Button
                        disabled={pageState.processing}
                        style={{ color: currentTheme.primary }}
                        icon={"clock"}
                        onClick={handleOnSchedule}
                      >
                        {t("reporting.view.schedule")}
                      </Button>
                    </ToolbarItem>
                    <ToolbarSeparator />
                  </Fragment>
                  <Fragment>
                    <ToolbarItem className="reporting-toolbar-screenshot">
                      <Button
                        disabled={pageState.processing}
                        className="snapshot"
                        style={{}}
                        title={t("reporting.view.snapshot")}
                        icon={"photo-camera"}
                        onClick={handleOnSnapshot}
                      ></Button>
                    </ToolbarItem>
                    <ToolbarSeparator />
                  </Fragment>
                  {pageState.canEdit && !currentUser.ClientId && (
                    <Fragment>
                      <ToolbarItem className="reporting-toolbar-design">
                        <Button
                          disabled={pageState.processing}
                          style={{ color: currentTheme.primary }}
                          icon={"brush"}
                          onClick={handleOnGotoDesignMode}
                        >
                          {t("reporting.view.design")}
                        </Button>
                      </ToolbarItem>
                      <ToolbarSeparator />
                    </Fragment>
                  )}
                </Toolbar>
              </div>
              <div className="reporting-view-page-body">
                {/* <div className="reporting-view-page-title">
                                {pageState.reportTitle}
                            </div> */}
                <div className="reporting-view-page-paper">
                  <div className="content" ref={contentZoneRef}>
                    <TileLayout
                      ref={paperContentRef}
                      columns={isMobileTileLayout ? 1 : 24}
                      rowHeight={DEFAULT_ROW_HEIGHT}
                      positions={
                        isMobileTileLayout
                          ? mobileTilePositions
                          : pageState.tiles.map((item) => item.defaultPosition)
                      }
                      gap={{
                        rows: isMobileTileLayout ? 8 : 12,
                        columns: isMobileTileLayout ? 8 : 12,
                      }}
                      items={responsiveTiles}
                      onReposition={
                        isMobileTileLayout ? undefined : handleTilesReposition
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </Fragment>
        <Fragment>
          {pageState.settingsFormDialogOpen && (
            <Dialog className="widgetsettings-form-dialog" title={null}>
              <WidgetSettingsForm
                pageState={pageState}
                formState={pageState.settingsForm}
                onSettingsFormFieldValueChange={
                  handleOnSettingsFormFieldValueChange
                }
                onSave={handleOnSettingsFormSave}
                t={t}
                onClose={handleOnCloseSettingsForm}
                formValidator={settingsFormValidator}
              />
            </Dialog>
          )}
          <style>
            {`
                            `}
          </style>
        </Fragment>
        <Fragment>
          {pageState.filterFormDialogOpen && (
            <Dialog className="widget-filter-form-dialog" title={null}>
              <WidgetFilterFormSinglePage
                pageState={pageState}
                formState={pageState.filterForm}
                canManageSearchSchema={canManageSearchSchema}
                formValidator={filterFormValidator}
                onFormSave={handleOnFilterFormSave}
                onFormSearchSchemaSave={handleOnFilterFormSearchSchemaSave}
                onFormSearchSchemaLoad={handleOnFilterFormSearchSchemaLoad}
                onPrevious={handleOnFilterFormPrevious}
                onNext={handleOnFilterFormNext}
                onFormValueChange={handleOnFilterFormValueChange}
                onFilterParameterChange={handleOnFilterParameterChange}
                onClear={(e) => {
                  dispatch(clearFilterForm());
                }}
                onSearchChange={handleOnFilterSearchChange}
                onKeyChange={handleKeyChange}
                onClose={(e) => {
                  dispatch(closeFilterForm());
                }}
              />
            </Dialog>
          )}
          <style>
            {`
                            `}
          </style>
        </Fragment>
        <Fragment>
          {pageState.filterFormValueKeysDialogOpen && (
            <Dialog className="filter-form-value-keys-dialog" title={null}>
              <ReportingViewPageKeyValues
                pageState={pageState}
                formState={pageState.filterFormValueKeys}
                onFormSave={handleOnFilterFormSearchSchemaSave}
                onFormValueChange={handleOnFilterFormValueKeysValueChange}
                onClose={(e) => {
                  dispatch(closeFilterFormValueKeys());
                }}
              />
            </Dialog>
          )}
          <style>
            {`
                            `}
          </style>
        </Fragment>
        <Fragment>
          {
            pageState.schedulePageOpen && (
              <div
                onClick={handleOnWidgetSchedule(pageState.currentWidget.Id)}
              ></div>
            )
            // <Dialog  className="schedule-form-dialog" title="Confirm Schedule" onClose={() => dispatch(closeSchedulePopup())}>
            //     <p style={{ margin: "0 0 16px 0" }}>
            //         Are you sure you want to schedule this widget?
            //     </p>

            //     <DialogActionsBar>
            //         <Button onClick={() => dispatch(closeSchedulePopup())}>No</Button>
            //         <Button themeColor="primary" onClick={() => handleOnWidgetSchedule(pageState.currentWidget.Id)}>
            //             Yes
            //         </Button>
            //     </DialogActionsBar>
            // </Dialog>
          }
        </Fragment>
      </Page>
      <style>
        {`
                    /*page class*/                    
                    reporting-view-page
                    {                        
                        padding-top: ${currentTheme.darkTheme ? "16px" : 0};
                        background-image: ${currentTheme.darkTheme ? currentTheme.appBarBgImage : "none"};                        
                    }

                    reporting-view-page .display-none
                    {
                        display: none;
                    }   
                        
                  
                    /*the loader*/
                    .reporting-view-page > .content .page-loader
                    {
                      position: fixed;
                      z-index: 99999;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      display: flex;
                      flex-direction: column;
                      justify-content: center;
                      align-items: center;
                      width: max-content;
                      max-width: calc(100vw - 32px);
                      padding: 20px;
                      text-align: center;
                      background-color: ${currentTheme.componentBg};
                      border: 1px solid ${currentTheme.separatorColor};
                      border-radius: 10px;
                    }
                    /*the loader*/                                 

                  
                    /*content*/
                    .reporting-view-page
                    {
                        margin-bottom: 50px;
                    }

                    .reporting-view-page .reporting-view-page-content
                    {
                        background-color: ${currentTheme.reportViewTileBg};
                        display: flex;
                        flex-direction: column;
                        align-items: stretch;
                        height: 100%;
                        overflow: hidden;
                        /*border-left: 1px solid rgba(0,0,0,0.12);*/
                        flex:1;
                    }
 
                    /*content*/

                    /*body*/                   

                    .reporting-view-page .reporting-view-page-body
                    {
                        display: flex;
                        flex-direction: column;
                        align-items: stretch;
                        flex: 1;
                        height: 100%;
                        overflow: hidden;
                    }

                    .reporting-view-page .reporting-view-page-body .reporting-view-page-title
                    {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding: 12px;
                        border-bottom: 1px solid ${currentTheme.separatorColor};
                        border-radius: 6px;
                        margin: 0px;
                        font-weight: 500;
                    }
                    /*body*/

                    /*toolbar*/
                    .reporting-view-page .toolbar .k-toolbar
                    {
                      width: 100%;
                      border-left: none !important;
                      border-bottom: 1px solid ${currentTheme.separatorColor};
                      border-top: none !important;
                      border-right: none !important;
                      padding: 3px 4px 3px 0px;
                      background-color: ${currentTheme.toolbarBg};/*transparent;*/
                      direction: ${appearance.isRightToLeft ? "rtl" : "ltr"}
                    }

                    .reporting-view-page .toolbar .k-button
                    {
                      /*the toolbar buttons*/
                      border: none;
                      padding: 6px 8px;
                      background:transparent;
                    }

                    .reporting-view-page .toolbar .k-separator 
                    {
                        border-color: ${currentTheme.primary}
                    }

                    .reporting-view-page .toolbar .k-toolbar .k-split-button:focus, .form-root .toolbar .k-toolbar .k-split-button.k-focus,
                    .reporting-view-page .toolbar .k-toolbar .k-button-solid-base:focus, .form-root .toolbar .k-toolbar .k-button-solid-base.k-focus
                    {
                        box-shadow: none !important;
                        border: none !important;
                    }

                    .reporting-view-page .toolbar .k-toolbar .k-button:active::before, .reporting-view-page .toolbar .k-toolbar .k-button:hover::before,
                    .reporting-view-page .toolbar .k-toolbar .k-button:focus::before, .reporting-view-page .toolbar .k-toolbar .k-button:focus-within::before                        
                    {
                        opacity: 0 !important;
                        border: none !important;
                        box-shadow: none !important;
                    }

                    .reporting-view-page .toolbar .k-toolbar .k-dropdown-button.k-focus .k-button::after
                    {
                        /*border: 1px solid ${currentTheme.componentBg} !important;*/
                        box-shadow: none !important;
                    }                       

                    .reporting-view-page .toolbar .k-toolbar .k-button .k-button-text
                    {
                        font-size: 13px !important;
                        font-weight: 400;
                        color: ${currentTheme.componentText};
                    }

                    .reporting-view-page .toolbar .k-button-icon
                    {
                      font-weight: 500;
                      color: ${currentTheme.primary};*/
                    }

                    .reporting-view-page .toolbar .is-live-report .k-button-icon
                    {
                        padding: 2px 4px;
                        font-size: 20px;
                    }

                    .reporting-view-page .toolbar .k-toolbar .k-button:hover .k-button-text
                    {
                        font-weight: 700;
                        font-size: 12.2px;
                    }
                    /*form toolbar*/

                    @media (max-width: 1024px) {
                      .reporting-view-page > .content {
                        overflow: auto;
                        padding-bottom: calc(80px + env(safe-area-inset-bottom));
                      }

                      .reporting-view-page .reporting-view-page-content,
                      .reporting-view-page .reporting-view-page-body {
                        height: auto;
                        min-height: 100%;
                        overflow: visible;
                      }

                      .reporting-view-page .toolbar .k-toolbar {
                        flex-wrap: wrap;
                        gap: 4px;
                        padding: 6px 8px;
                      }

                      .reporting-view-page .toolbar .k-separator {
                        display: none;
                      }

                      .reporting-view-page .toolbar .reporting-toolbar-update,
                      .reporting-view-page .toolbar .reporting-toolbar-cancel,
                      .reporting-view-page .toolbar .reporting-toolbar-paper-height,
                      .reporting-view-page .toolbar .reporting-toolbar-zoom,
                      .reporting-view-page .toolbar .reporting-toolbar-schedule,
                      .reporting-view-page .toolbar .reporting-toolbar-design {
                        display: none !important;
                      }

                      .reporting-view-page .toolbar .reporting-toolbar-global-filter,
                      .reporting-view-page .toolbar .reporting-toolbar-generate,
                      .reporting-view-page .toolbar .reporting-toolbar-live,
                      .reporting-view-page .toolbar .reporting-toolbar-screenshot {
                        display: flex;
                      }

                      .reporting-view-page .reporting-view-page-paper {
                        overflow-x: hidden;
                      }

                      .reporting-view-page .reporting-view-page-paper > .content {
                        min-width: 0;
                        width: 100%;
                        transform: none !important;
                      }

                      .reporting-view-page .reporting-view-page-paper .k-tilelayout,
                      .reporting-view-page .reporting-view-page-paper .k-tilelayout-item {
                        width: 100%;
                        min-width: 0;
                      }
                    }

                    /*paper*/
                    .reporting-view-page > .content  .reporting-view-page-paper
                    { 
                        display: flex;
                        flex-direction: column;
                        align-items: stretch;
                        flex:1;
                        overflow: auto;

                        /*prevent selection*/
                        user-select: none;
                        -moz-user-select: none;
                        -webkit-user-select: none;
                        -ms-user-select: none;
                    }

                    .reporting-view-page > .content  .reporting-view-page-paper > .content
                    {
                        transform: scale(${pageState.zoom}) translateX(0) translateY(0);  
                        transform-origin: ${zoomTransformOrigin};
                        /*background-image: radial-gradient(${currentTheme.separatorColor} 20%, transparent 20%);
                        background-color: ${currentTheme.componentBg};
                        background-position: 0 0, 20px 20px;
                        background-size: 6px 6px;
                        background-color: ${currentTheme.componentBg};*/

                        /*border: 1px solid ${currentTheme.separatorColor};*/
                        padding: 0px;
                        flex: 1; 
                    }
                    
                    .reporting-view-page > .content .k-tilelayout
                    {
                        /*background-image: radial-gradient(${currentTheme.separatorColor} 20%, transparent 20%);
                        background-position: 0 0, 20px 20px;
                        background-size: 6px 6px;*/

                        background-color: ${currentTheme.reportViewTileBg};
                        /*background-color: ${currentTheme.componentBg};*/
                        /*border: 1px solid ${currentTheme.separatorColor};*/
                        padding: 0px;
                        flex: 1;
                    }

                    .reporting-view-page > .content .k-tilelayout .k-tilelayout-item
                    {
                        border: none;
                    }

                    .reporting-view-page .k-tilelayout .k-card
                    {
                        border-radius: 0;
                    }
                    /*paper*/


                    /*settings form dialog*/
                    .widgetsettings-form-dialog
                    {
                        height: 100%;
                    }
                    
                    .widgetsettings-form-dialog .k-dialog
                    {
                        width: min(950px, calc(100vw - 32px));
                        max-width: calc(100vw - 32px);
                        height: 70%;
                        min-height: 0;
                        max-height: calc(100dvh - 32px);
                        border-radius: 8px;
                    }
                    
                    .widgetsettings-form-dialog .k-dialog-content
                    {
                        padding: 0 !important;
                        min-height: 0;
                        overflow: hidden;
                    }
                    
                    /*settings form dialog*/     
                    
                    /*filter form dialog*/
                    .widget-filter-form-dialog
                    {
                       height: calc(100dvh - 32px);
                       max-height: calc(100dvh - 32px);
                       direction: ${appearance.isRightToLeft ? "rtl" : "ltr"}
                    }
                    
                    .widget-filter-form-dialog .k-dialog
                    {
                        width: min(950px, calc(100vw - 32px));
                        min-width: min(800px, calc(100vw - 32px));
                        min-height: min(400px, calc(100dvh - 32px));
                        max-width: calc(100vw - 32px);
                        max-height: 100%;
                        border-radius: 6px;
                    }
                    
                    .widget-filter-form-dialog .k-dialog-content
                    {
                        padding: 0 !important;
                        min-height: 0;
                        overflow: hidden;
                    }

                    @media (max-width: 700px)
                    {
                        .widget-filter-form-dialog
                        {
                            height: calc(100dvh - 16px);
                            max-height: calc(100dvh - 16px);
                        }

                        .widget-filter-form-dialog .k-dialog
                        {
                            width: calc(100vw - 16px);
                            min-width: 0;
                            height: 100%;
                            min-height: 0;
                            max-width: calc(100vw - 16px);
                            max-height: calc(100dvh - 16px);
                        }

                        .widget-filter-form .toolbar .k-toolbar
                        {
                            flex-wrap: wrap;
                            row-gap: 2px;
                            padding: 3px 4px;
                        }

                        .widget-filter-form .form-content
                        {
                            padding: 8px;
                        }

                        .widget-filter-form-group > .content
                        {
                            min-width: 0;
                            padding: 8px;
                        }

                        .widget-filter-form-search .queryBuilder,
                        .widget-filter-form-search .queryBuilder .ruleGroup,
                        .widget-filter-form-search .queryBuilder .ruleGroup-body,
                        .widget-filter-form-search .queryBuilder .rule
                        {
                            min-width: 0;
                            width: 100%;
                        }

                        .widget-filter-form-search .queryBuilder .rule
                        {
                            align-items: stretch;
                            flex-wrap: wrap;
                            gap: 4px;
                        }

                        .widget-filter-form-search .queryBuilder .rule-fields,
                        .widget-filter-form-search .queryBuilder .rule-operators,
                        .widget-filter-form-search .queryBuilder .rule-value,
                        .widget-filter-form-search .queryBuilder .k-input,
                        .widget-filter-form-search .queryBuilder .k-dropdownlist,
                        .widget-filter-form-search .queryBuilder .k-multiselect
                        {
                            box-sizing: border-box;
                            flex: 1 1 100%;
                            width: 100%;
                            max-width: 100%;
                            margin-right: 0;
                        }

                        .widget-filter-form-search .queryBuilder .rule-remove,
                        .widget-filter-form-search .queryBuilder .rule-cloneRule
                        {
                            flex: 0 0 auto;
                            margin: 4px 0 0;
                        }

                        .widget-filter-form-search .query-value-editor-date-range,
                        .widget-filter-form-search .query-value-editor-datetime-range
                        {
                            display: grid !important;
                            grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
                            flex: 1 1 100% !important;
                            gap: 8px;
                            min-width: 0;
                            width: 100%;
                        }

                        .widget-filter-form-search .query-value-editor-date-range .pro-datepicker,
                        .widget-filter-form-search .query-value-editor-datetime-range .pro-datetimepicker
                        {
                            min-width: 0;
                            width: 100%;
                            margin-left: 0 !important;
                        }

                        .widget-filter-form-search .query-value-editor-date-range .k-field,
                        .widget-filter-form-search .query-value-editor-datetime-range .k-field,
                        .widget-filter-form-search .query-value-editor-date-range .k-datepicker,
                        .widget-filter-form-search .query-value-editor-datetime-range .k-datetimepicker
                        {
                            min-width: 0;
                            width: 100%;
                        }
                    }

                    @media (max-width: 480px)
                    {
                        .widget-filter-form-search .query-value-editor-date-range,
                        .widget-filter-form-search .query-value-editor-datetime-range
                        {
                            grid-template-columns: minmax(0, 1fr);
                        }
                    }
                    /*filter form dialog*/     

                    /*query builder*/
                    .widget-filter-form-search .ruleGroup, .widget-filter-form-search .ruleGroup-combinators,
                    .widget-filter-form-search .ruleGroup-addRule, .widget-filter-form-search .ruleGroup-addGroup,
                    .widget-filter-form-search .rule-remove, .widget-filter-form-search .ruleGroup-remove,
                    .widget-filter-form-search .rule-fields, .widget-filter-form-search .rule-operators,
                    .widget-filter-form-search .rule-value
                    {
                        border-color: ${currentTheme.componentBorderColor};
                        background-color: ${currentTheme.componentBg};
                        color: ${currentTheme.componentText};                                               
                    }

                    .widget-filter-form-search .rule-fields:focus, .widget-filter-form-search .rule-operators:focus,
                    .widget-filter-form-search .rule-value:focus
                    {
                        outline: none
                    }      
                    
                    
                    /*filter form-value-keys dialog*/
                    .filter-form-value-keys-dialog
                    {
                       height: 90%;
                    }
                    
                    .filter-form-value-keys-dialog .k-dialog
                    {
                        min-height: 200px;
                        /*max-height: 600px;  */
                        width: 500px;                      
                        border-radius: 6px;
                    }
                    
                    .filter-form-value-keys-dialog .k-dialog-content
                    {
                        padding: 0 !important;
                    }
                    /*filter form-value-keys dialog*/     
                    `}
      </style>
    </Fragment>
  );
};

//export const ReportingViewPage = {Component: ReportingView};
